import React, { useEffect, useRef, useState } from 'react';

function PlaylistActionsMenu({ onEdit, onDelete }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen((prev) => !prev);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(false);
    onEdit();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(false);
    onDelete();
  };

  return (
    <div className="playlist-actions-menu" ref={menuRef}>
      <button
        type="button"
        className="playlist-actions-menu__trigger"
        aria-label="Playlist options"
        onClick={handleToggle}
      >
        <i className="material-icons">more_vert</i>
      </button>

      {isOpen && (
        <div className="playlist-actions-menu__dropdown">
          <button
            type="button"
            className="playlist-actions-menu__option"
            onClick={handleEdit}
          >
            <i className="material-icons">edit</i>
            Edit
          </button>
          <button
            type="button"
            className="playlist-actions-menu__option"
            onClick={handleDelete}
          >
            <i className="material-icons">delete</i>
            Delete
          </button>
        </div>
      )}
    </div>
  );
}

export default PlaylistActionsMenu;
